export const plans = [
    {label: "All", key: "all"}, 
    {label: "Premium", key: "premium"}, 
    {label: "Verified", key: "verified"}, 
    {label: "Unverified", key: "unverified"}, 
    {label: "Outbound", key: "outbound"}
] 